/* RC design system — client-side facet filtering (no page reload).
   Fixes: (1) full-page reload on every filter click, (2) the AND bug where two
   boxes in one group (e.g. two Heights) returned zero products. Here: OR WITHIN a
   group, AND ACROSS groups — the correct faceted-search behaviour.

   Progressive enhancement: with JS off, the server renders the full collection and
   the checkboxes are inert (no broken links). With JS on, cards show/hide instantly,
   the count + chips + empty-state update, and the URL stays shareable via pushState.

   Cards must carry data-facets + data-f-<group> (space-separated tag values). The
   sidebar controls are .rcds-facet-cb checkboxes with data-group + value. Wired for
   groups: height, drawers, year, wb, roof, ptype. */
(function () {
  if (window.__rcdsFacets) return;
  window.__rcdsFacets = true;

  /* 'product' and 'pkg' added 2026-08-30 for Sophia's Products and With/Without Partition
     filters. A group listed here is read from a card's data-f-<group>. */
  /* 'w' and 'h' added 2026-09-01 for Sophia's two-question drawer selector. They read
     data-f-w / data-f-h, which snippets/rcds-collection-card-item.liquid derives from the
     product TITLE. Deliberately NOT reusing 'height': that group reads the height-NNN mm
     tag, and the tag is missing on 11 drawer products and shared by PAIRS with different
     real heights, so it cannot drive a size picker. Both groups coexist; the sidebar
     height facet is untouched. */
  var GROUPS = ['height', 'drawers', 'year', 'wb', 'roof', 'ptype', 'trade', 'product', 'pkg', 'w', 'h', 'stype', 'veh'];
// 'veh' (2026-11-04): Vehicle on the side-package and full-package collections, read from data-f-veh.
// 'stype' (2026-09-21): Product Type on the two shelving collections. NOT an identity
// group, so it behaves like ptype: a card with no stype value still matches. Every card
// on those two pages carries exactly one (verified 42/42 and 21/21), and the sidebar
// renders nowhere else, so no selection can exist over blank cards.
// ⛔ A group missing from this list renders its checkboxes and does NOTHING when clicked,
// which is the 'filters do nothing when pressed' failure already on record here. // pkg re-added 2026-09-02 for With/Without Partition (real tags, 0 products until Karen tags), NOT the old title fabrication
  var LABELS = {}; // value -> pretty label, learned from the checkbox labels
  var DIM_GROUPS = ['w', 'h', 'pkg'];   // identity groups: a card with no value is NOT a match. 'pkg' identity so an empty With/Without Partition (0 tagged) shows ZERO, and after tagging shows ONLY tagged products.

  function dataKey(g) { return 'f' + g.charAt(0).toUpperCase() + g.slice(1); } // height -> fHeight

  // MODULE-SCOPE STATE, not locals. rcds-vehicle-swap.js replaces the results section's
  // innerHTML, which detaches every checkbox and card this engine had captured. If these
  // lived in init()'s closure the delegated handlers below would keep filtering DETACHED
  // nodes: the click registers, chips render, the grid never changes. Holding them at
  // module scope lets init() re-scan and the already-bound handlers pick the new nodes up.
  var grid, cbs = [], cards = [], countNode, chipHosts = [], liveVals = {};
  var bound = false;   // document-level listeners must bind exactly once

  function init() {
    grid = document.getElementById('rcds-results');
    if (!grid) return;
    cbs = [].slice.call(document.querySelectorAll('.rcds-facet-cb'));
    if (!cbs.length) return;

    cards = [].slice.call(grid.querySelectorAll('[data-facets]'));
    // group|value pairs present on >=1 card here, so universal-fit tells a REAL value (accessory
    // cards fit it) from a phantom value no product carries (an empty Plumber must match NOTHING).
    liveVals = {};
    cards.forEach(function (c) {
      GROUPS.forEach(function (g) {
        (c.getAttribute('data-f-' + g) || '').split(/\s+/).forEach(function (v) {
          if (v) { liveVals[g + '|' + v] = true; }
        });
      });
    });
    /* 2026-08-30: neither of the two classes below is ever rendered, so the count silently
       never updated - the heading kept saying "12 products" while the grid showed 1. The class
       the section-header snippet actually emits is .rcds-heading, inside
       .rcds-section-header__text. Kept scoped to that wrapper rather than matching .rcds-heading
       globally: .rcds-heading appears ~10 times on a collection page and only the one inside
       .rcds-collection__head .rcds-section-header__text is the product count. */
    countNode = document.querySelector('.rcds-collection__head .rcds-section-header__text > .rcds-heading, .rcds-collection__head .rcds-section-header__title, .rcds-collection__head .rcds-section-header__heading');
    chipHosts = [].slice.call(document.querySelectorAll('[data-rcds-facet-chips]'));

    // learn pretty labels from the checkbox rows
    cbs.forEach(function (cb) {
      var lbl = cb.closest('label') || cb.parentNode;
      var txt = lbl ? (lbl.querySelector('.rcds-filter__label, .rcds-pfilter__label') || {}).textContent : null;
      /* The size pills are a radio followed by a sibling <label for=...>, not a wrapping
         label, so the lookup above finds nothing and a chip would fall back to the raw
         value ("w-33"). Kept for robustness even though dimension chips are suppressed. */
      if (!txt && cb.id) {
        var sib = document.querySelector('label[for="' + cb.id + '"]');
        if (sib) { txt = sib.textContent; }
      }
      if (txt) LABELS[cb.dataset.group + ':' + cb.value] = txt.trim();
    });

    function selected() {
      var sel = {};
      cbs.forEach(function (cb) {
        if (!cb.checked) { return; }
        var arr = (sel[cb.dataset.group] = sel[cb.dataset.group] || []);
        /* Every option exists twice (desktop sidebar + mobile drawer) and both copies are
           now kept in sync, so without this guard a single tick wrote the value into the URL
           twice (?f_ptype=v&f_ptype=v) and painted the removable chip four times. */
        if (arr.indexOf(cb.value) === -1) { arr.push(cb.value); }
      });
      return sel;
    }

    // Read a card's values for a group from data-f-<group>
    function cardVals(card, g) {
      var v = card.getAttribute('data-f-' + g) || '';
      return v ? v.split(/\s+/) : [];
    }
    function cardMatches(card, sel) {
      return Object.keys(sel).every(function (g) {            // AND across groups
        var have = cardVals(card, g);
        // UNIVERSAL-FIT WILDCARD. A card with NO value for a group is compatible with
        // every value in it, so it must not be filtered out by that group.
        // Sophia 2026-08-13: "the Door Hinge Kit is not working correctly in the product
        // section. It is compatible with every full partition kit." Root cause: RSCGBDHK
        // carries ptype-hinge/ptype-lockable but no roof-*, wb-* or year-* tags, because it
        // genuinely fits them all. Without this rule the .some() below can never be true for
        // an empty array, so ticking ANY roof/wheelbase/year box made the universal hinge kit
        // disappear on every partition collection.
        // Fixed HERE and not in the tag data on purpose: the kit sits in all 5 partition
        // collections, so tagging it wb-118..wb-159 would pollute collection.all_tags and put
        // 118"/130"/135" wheelbases on the Mercedes filter.
        /* ...but a DIMENSION is identity, not compatibility. A joining bracket and the five
           top trays carry no width or height, and under the rule above they matched every
           size, so picking 33" x 12.8" put 3 drawer units and 6 dimensionless accessories in
           the same grid while the count said 3. For 'w' and 'h' only, no value means no
           match. Every other group keeps the universal-fit behaviour above, which the hinge
           kit still depends on. */
        if (have.length === 0) {
          if (DIM_GROUPS.indexOf(g) !== -1) { return false; } // identity group (w/h/pkg): no value = no match
          // universal-fit ONLY toward values that exist on some card. A zero-count selection (empty
          // Plumber) matches nothing; a real trade keeps its universal accessories.
          return sel[g].some(function (v) { return liveVals[g + '|' + v]; });
        }
        return sel[g].some(function (v) { return have.indexOf(v) !== -1; }); // OR within group
      });
    }

    var emptyEl = document.querySelector('[data-rcds-facet-empty]');

    function apply(push) {
      var sel = selected(), shown = 0;
      cards.forEach(function (card) {
        var ok = cardMatches(card, sel);
        card.hidden = !ok;
        if (ok) shown++;
      });
      var hasFilter = Object.keys(sel).length > 0;
      /* 2026-08-30. The grid is CSS-clamped by DOM POSITION
         (.rcds-collection__grid--clamp > .rcds-fitem:nth-child(n+7), n+5 on mobile), and that
         clamp was only ever lifted by the "View all products" checkbox. Filtering hides
         non-matches with [hidden] but leaves every card in place, so a match sitting at
         position 35 stayed display:none and the shopper saw an EMPTY grid while the heading
         said "4 products". Flag the grid while a filter is active so the clamp can stand down.
         Verified on /collections/ford: ticking Roof & Floor Anchors matched 4 cards at
         nth-child 35-38 and showed none of them. */
      if (grid) { grid.classList.toggle('is-facet-filtered', hasFilter); }
      if (countNode) countNode.textContent = (shown === 1 ? '1 product' : shown + ' products');
      if (emptyEl) emptyEl.hidden = !(hasFilter && shown === 0);
      renderChips(sel);
      if (push) writeUrl(sel);
      // Notify the Load-More pager (rcds-collection-more.js) so it re-pages the filtered set.
      document.dispatchEvent(new CustomEvent('rcds:facets-applied', { detail: { shown: shown } }));
    }

    function buildChips(sel) {
      // Build chip nodes with safe DOM methods (no innerHTML) — values are our own
      // facet tags + label text, but textContent keeps it XSS-safe regardless.
      var frag = document.createDocumentFragment();
      Object.keys(sel).forEach(function (g) {
        /* Width and height are shown by the selector's own "You selected" panel, so a chip
           would state the same thing twice directly beneath it. */
        if (DIM_GROUPS.indexOf(g) !== -1) { return; }
        sel[g].forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rcds-facet-chip';
          b.setAttribute('data-clear-group', g);
          b.setAttribute('data-clear-value', v);
          b.textContent = (LABELS[g + ':' + v] || v) + ' ';
          var x = document.createElement('span');
          x.setAttribute('aria-hidden', 'true');
          x.textContent = '×';
          b.appendChild(x);
          frag.appendChild(b);
        });
      });
      return frag;
    }

    function renderChips(sel) {
      if (!chipHosts.length) return;
      chipHosts.forEach(function (h) {
        while (h.firstChild) h.removeChild(h.firstChild);
        h.appendChild(buildChips(sel));
      });
    }

    function writeUrl(sel) {
      var qs = new URLSearchParams();
      GROUPS.forEach(function (g) { (sel[g] || []).forEach(function (v) { qs.append('f_' + g, v); }); });
      var url = location.pathname + (qs.toString() ? '?' + qs.toString() : '');
      try { history.pushState({ rcdsFacets: true }, '', url); } catch (e) {}
    }

    function readUrl() {
      var qs = new URLSearchParams(location.search), any = false;
      cbs.forEach(function (cb) {
        var on = qs.getAll('f_' + cb.dataset.group).indexOf(cb.value) !== -1;
        cb.checked = on; if (on) any = true;
      });
      apply(false);
      return any;
    }

    // Bind once. Re-running init() after a swap must NOT stack duplicate handlers
    // (that would double-render chips and double-push history entries).
    if (bound) { readUrl(); return; }
    bound = true;

    // live filtering on any checkbox change
    document.addEventListener('change', function (e) {
      if (!(e.target.classList && e.target.classList.contains('rcds-facet-cb'))) { return; }
      /* 2026-08-31 - the same option is rendered twice on every collection that has both a
         desktop sidebar and a mobile drawer. apply() reads the union so filtering was always
         correct, but the twin box stayed visually unticked, so re-opening the drawer showed
         an empty-looking panel filtering a narrowed grid. Mirror the state onto the twin. */
      var mg = e.target.dataset.group, mv = e.target.value, mon = e.target.checked;
      cbs.forEach(function (cb) {
        if (cb !== e.target && cb.dataset.group === mg && cb.value === mv) { cb.checked = mon; }
      });
      apply(true);
    });
    // chip remove
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('.rcds-facet-chip');
      if (chip) {
        var g = chip.getAttribute('data-clear-group'), v = chip.getAttribute('data-clear-value');
        cbs.forEach(function (cb) { if (cb.dataset.group === g && cb.value === v) cb.checked = false; });
        apply(true);
        return;
      }
      // "Apply Filters" button (partition sidebar) — no reload, just apply current selection
      var applyBtn = e.target.closest && e.target.closest('[data-pfilter-apply]');
      if (applyBtn) { e.preventDefault(); apply(true); return; }
      // "Clear all" / "Reset all" links inside a facet sidebar — clear without navigating
      var clearLink = e.target.closest && e.target.closest('[data-rcds-facet-clear]');
      if (clearLink) { e.preventDefault(); cbs.forEach(function (cb) { cb.checked = false; }); apply(true); }
    });
    window.addEventListener('popstate', readUrl);

    /* 2026-08-30 - never paint a control that cannot do anything.
       The filter vocabulary is shared across collections, so a value with no product on THIS
       page renders a checkbox that ticks and matches nothing. Measured on /collections/ford:
       Driver Side, Passenger Side and Drawers all matched 0 of 38 cards while looking exactly
       as clickable as the ones that work. Count each option's real matches once at init and
       hide the empties (and their <li>, so no bullet gap is left behind).
       A checked option is never hidden - a shared or reloaded facet URL must stay visible and
       undoable rather than silently disappearing. */
    function pruneDeadOptions() {
      var counts = {}, i, j, g, vals;
      for (i = 0; i < cards.length; i++) {
        for (j = 0; j < GROUPS.length; j++) {
          g = GROUPS[j];
          vals = (cards[i].getAttribute('data-f-' + g) || '').split(/\s+/);
          for (var k2 = 0; k2 < vals.length; k2++) {
            if (vals[k2]) { counts[g + '|' + vals[k2]] = (counts[g + '|' + vals[k2]] || 0) + 1; }
          }
        }
      }
      for (i = 0; i < cbs.length; i++) {
        var cb = cbs[i];
        if (cb.checked) { continue; }
        // show-empty: a filter empty BY DESIGN (Plumber / With Partition) is never pruned even at 0.
        if (cb.hasAttribute('data-keep-empty')) { continue; }
        if (counts[cb.dataset.group + '|' + cb.value]) { continue; }
        var li = cb.closest ? cb.closest('li') : null;
        (li || cb.parentNode).style.display = 'none';
      }
      /* How many cards carry NO value at all in a group. cardMatches() lets those through
         whatever is ticked, so they count towards an option's real on-screen result. */
      var blanks = {};
      for (j = 0; j < GROUPS.length; j++) {
        g = GROUPS[j]; blanks[g] = 0;
        for (i = 0; i < cards.length; i++) {
          if (!(cards[i].getAttribute('data-f-' + g) || '').trim()) { blanks[g]++; }
        }
      }
      function shownBy(cb) {
        return (counts[cb.dataset.group + '|' + cb.value] || 0) + blanks[cb.dataset.group];
      }

      /* 2026-08-31 - a GROUP that cannot narrow anything is a dead control too.
         Measured on the four vehicle partition collections: on /collections/ram-partitions
         every Model Year, Wheelbase and Roof Height option matches all 3 cards, so ticking
         any of them leaves the grid untouched. That is precisely the "filters did nothing
         when I pressed them" the client reported, and it is still live there.
         Hide the GROUP, never the lone option: on /collections/ford-partitions "148-inch"
         also matches everything, but removing just that checkbox would read as "nothing
         fits a 148 van", which is a worse lie than a no-op control. A group is only hidden
         when NO visible option in it can remove a single card. Any checked option keeps its
         whole group visible, so a shared facet URL stays undoable. */
      var groupEls = document.querySelectorAll('.rcds-filters__group, .rcds-pfilter__group');
      for (i = 0; i < groupEls.length; i++) {
        var opts = groupEls[i].querySelectorAll('.rcds-facet-cb');
        if (!opts.length) { continue; }
        var alive = 0, narrowing = 0, anyChecked = false;
        for (j = 0; j < opts.length; j++) {
          var host = opts[j].closest ? opts[j].closest('li') : null;
          if (host && host.style.display === 'none') { continue; }
          alive++;
          if (opts[j].checked) { anyChecked = true; }
          // a show-empty option keeps its whole group visible so an all-empty Packages group survives.
          if (opts[j].hasAttribute('data-keep-empty')) { anyChecked = true; }
          if (shownBy(opts[j]) < cards.length) { narrowing++; }
        }
        if (anyChecked) { continue; }
        if (alive === 0 || narrowing === 0) { groupEls[i].style.display = 'none'; }
      }
    }
    pruneDeadOptions();

    readUrl();
  }

  // Public re-arm hook for rcds-vehicle-swap.js after it replaces the results section.
  window.rcdsFacetsInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
